<template>
  <div class="wecom">
    <router-view>

    </router-view>
  </div>
</template>
  
  <script>
export default {};
</script>
  
  <style lang="scss">
.wecom {
  font-family: Noto Sans SC-Medium, Noto Sans SC;
  height: 100vh;
  background-image: url("../../assets/images/wecom/page_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .van-cell {
    background-color: transparent;
  }
}
</style>
